import { render, staticRenderFns } from "./spot_space.vue?vue&type=template&id=e1b2a5dc&scoped=true&"
import script from "./spot_space.vue?vue&type=script&lang=js&"
export * from "./spot_space.vue?vue&type=script&lang=js&"
import style0 from "./spot_space.vue?vue&type=style&index=0&id=e1b2a5dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b2a5dc",
  null
  
)

export default component.exports